export const EDITOR_STATS_EDIT_TYPES = [
  {value: 'all', label: 'All'},
  {value: 'sbs', label: 'Primary QC'},
  {value: 'supplemental', label: 'Supplemental'},
  {value: 'bnt', label: 'BNT'},
];

export const EDITOR_STATS_EDIT_TYPE_DEFAULT = EDITOR_STATS_EDIT_TYPES[0];
export const EDITOR_STATS_EDIT_TYPE_DEFAULT_VALUE = EDITOR_STATS_EDIT_TYPES[0].value;
